import { Field, FieldArray, formValueSelector } from "redux-form";
import InputWithLabel from "shared/components/redux-form/InputWithLabel";
import { maxLength, onlyNumber } from "core/utils/Normalizer";
import { BracketTeam } from "core/models/Bracket";
import { TournamentConfig } from "core/models/Tournament";
import clsx from "clsx";
import Select from "shared/components/redux-form/Select";
import { useSelector } from "react-redux";

interface AddResultProps {
  bracketTeams: BracketTeam[];
  tournamentConfig: TournamentConfig[];
  bestOfNumber: any;
  isRoundRobin: boolean;
  matchOptions: any;
  disabledValues?: number[];
}

const renderPlayerStats = ({ fields, min, max }: any) => (
  <>
    {fields.map((stat: any, index: number) => (
      <Field
        key={index}
        name={stat.name}
        component={InputWithLabel}
        placeholder={stat.placeHolder}
        // label={stat.placeHolder}
        normalize={(value: string) => onlyNumber(value, min, 10000)}
      />
    ))}
  </>
);

const renderTeamFields = ({ fields, bracketTeams, min, max }: any) => (
  <div className="qualifer-grid-form-wrapper">
    {fields.map((team: any, index: number) => (
      <div key={index} className="qualifer-grid-form-100">
        <h5>{bracketTeams?.[index]?.name || `Team ${index + 1}`}</h5>
        <Field
          name={`${team}.score`}
          component={InputWithLabel}
          placeholder="Enter Score"
          // label="Score"
          normalize={(value: string) => onlyNumber(value, min, 10000)}
        />
      </div>
    ))}
  </div>
);

const renderPlayerFields = ({
  fields,
  bracketTeams,
  tournamentConfig,
  parentName,
}: any) => {
  const players = fields.getAll() || [];

  const groupedPlayers: any = {};
  players.forEach((p: any, idx: number) => {
    const tid = p.teamId;
    if (!groupedPlayers[tid]) groupedPlayers[tid] = [];
    groupedPlayers[tid].push({ ...p, fieldIndex: idx });
  });

  return (
    <div className="qualifer-grid-form-wrapper">
      {bracketTeams.map((team: any) => {
        const teamPlayers = groupedPlayers[team.id] || [];

        return (
          <div key={team.id} className="qualifer-grid-form-100">
            {teamPlayers.map((player: any) => (
              <div key={player.userId} className="player-block">
                <h5 className="player-name">{player.userName}</h5>

                {tournamentConfig.map((cfg: any, cfgIndex: number) => (
                  <Field
                    key={cfgIndex}
                    name={`${parentName}[${player.fieldIndex}].stats.${cfg.key}`}
                    component={InputWithLabel}
                    placeholder={cfg.placeHolder}
                    normalize={(value: string) => onlyNumber(value, 0, 10000)}
                  />
                ))}
              </div>
            ))}
          </div>
        );
      })}
    </div>
  );
};

export default function AddResultForm({
  bracketTeams,
  tournamentConfig,
  bestOfNumber,
  isRoundRobin,
  matchOptions,
  disabledValues,
}: AddResultProps) {
  const matchFormatValue = useSelector((state: any) => {
    const selector = formValueSelector("add-qualifier");
    return selector(state, "match");
  });

  const requiredWins = Math.floor(bestOfNumber / 2) + 1;

  const min = 0;
  const max = requiredWins;

  if (bestOfNumber && isRoundRobin) {
    return (
      <>
        <Field
          name="match"
          component={Select}
          placeholder="Select Match Number"
          label="Match Number"
          options={matchOptions}
          searchable={false}
          cleanable={false}
        />

        <FieldArray
          name={`matchFormat.${matchFormatValue}.results`}
          props={{ bracketTeams, min, max }}
          component={renderTeamFields}
        />

        <div className={clsx("divider")}></div>

        <FieldArray
          name={`matchFormat.${matchFormatValue}.playerResults`}
          props={{
            tournamentConfig,
            bracketTeams,
            parentName: `matchFormat.${matchFormatValue}.playerResults`,
          }}
          component={renderPlayerFields}
        />
      </>
    );
  }

  return (
    <>
      {disabledValues && (
        <Field
          name="match"
          component={Select}
          placeholder="Select Match Number"
          label="Match Number"
          options={matchOptions}
          disabledItemValues={disabledValues}
          searchable={false}
          cleanable={false}
        />
      )}
      <FieldArray
        name="results"
        props={{ bracketTeams, min, max }}
        component={renderTeamFields}
      />
      <div className={clsx("divider")}></div>
      <FieldArray
        name="playerResults"
        props={{
          tournamentConfig,
          bracketTeams,
          parentName: "playerResults",
        }}
        component={renderPlayerFields}
      />
    </>
  );
}
